import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import Checkbox from "@mui/material/Checkbox";

// Components
import MobileItem from "components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import {BpCheckedIcon, BpIcon} from "components/WMS/AccordionShipment/checkboxIcons";

// Assets
import {blueColor} from "assets/jss/main";

RetailerToAddLine.propTypes = {
    onItemClick: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    logo: PropTypes.string.isRequired
};

function RetailerToAddLine({onItemClick, checked, id, name, count, logo, ...props}) {
    return (
        <MobileItem
            onClick={onItemClick}
            key={id}
        >
            <MobileItem.LeftSide
                title={name}
                subtitle={(
                    <>
                        {count} <FormattedMessage id={"wms.myPickingMission.articles"}/>
                    </>
                )}
            >
                <ThumbnailAndNotification link={logo} />
            </MobileItem.LeftSide>
            <MobileItem.RightSide>
                <Checkbox
                    checked={checked}
                    icon={<BpIcon />}
                    checkedIcon={<BpCheckedIcon />}
                    sx={{
                        marginRight: '16px',
                        color: blueColor,
                        '&.Mui-checked': {color: blueColor}
                    }}
                />
            </MobileItem.RightSide>
        </MobileItem>
    );
}

export default RetailerToAddLine;
